import { Text } from "react-native-paper";
import { useAppTheme } from "../../../useAppTheme";
import Box from "../../Box";

type Props = {
	label: string;
	score: number;
};

export const PteOverallScoreCard = ({ label, score }: Props) => {
	const theme = useAppTheme();

	return (
		<Box
			alignItems="center"
			borderWidth={5}
			borderColor={theme.colors.surface}
			borderRadius={theme.roundness * 2}
		>
			<Box
				width="100%"
				padding={10}
				alignItems="center"
				justifyContent="center"
				backgroundColor={theme.colors.tertiaryContainer}
				borderTopLeftRadius={theme.roundness * 2}
				borderTopRightRadius={theme.roundness * 2}
			>
				<Text
					variant="titleSmall"
					style={{ color: theme.colors.onSurface, textAlign: "center" }}
				>
					{label}
				</Text>
			</Box>
			<Box
				flex={1}
				width="100%"
				paddingHorizontal={10}
				paddingTop={16}
				paddingBottom={20}
				alignItems="center"
				justifyContent="center"
				backgroundColor={theme.colors.primary}
				style={{
					borderBottomLeftRadius: 99,
					borderBottomRightRadius: 99,
				}}
			>
				<Text
					variant="displayMedium"
					style={{
						color: theme.colors.white,
						...theme.typography.fonts.medium,
					}}
				>
					{Math.round(score)}
				</Text>
			</Box>
		</Box>
	);
};
